import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=369946ea&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=369946ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369946ea",
  null
  
)

export default component.exports